<template>
  <div class="Create alignment">
    <template>
      <v-flex xs12 sm12>
        <h3 v-if="edit" class="styleHeader">
          {{
            $t("pages.UserExtraction.Create.MappaturaUtenteEstrazioneModifica")
          }}
        </h3>
        <h3 v-else class="styleHeader">
          {{
            $t("pages.UserExtraction.Create.MappaturaUtenteEstrazioneAggiungi")
          }}
        </h3>
        <v-card class="styleDataTable">
          <v-form>
            <v-layout>
              <v-select
                v-model="extraction"
                :label="
                  $t(
                    'pages.UserExtraction.Create.MappaturaUtenteEstrazioneAggiungi'
                  )
                "
                required
                :items="extractions"
                :error-messages="extractionError"
                autocomplete
                item-text="name"
                item-value="id"
                @blur="$v.extraction.$touch()"
              ></v-select>
              <v-select
                v-model="user"
                :label="$t('pages.UserExtraction.Create.Utente')"
                required
                :disabled="edit"
                :items="users"
                :error-messages="usersErrors"
                autocomplete
                item-text="formattedName"
                item-value="Id"
                @blur="$v.user.$touch()"
              ></v-select>
            </v-layout>
          </v-form>
        </v-card>
        <v-btn
          class="white--text styleButtonTop styleAlignementSaveButton"
          @click="creatingMapping()"
          color="#279947"
        >
          <v-icon left>check_circle</v-icon>
          {{ $t("pages.UserExtraction.Create.Salva") }}
        </v-btn>
        <v-btn class="styleButtonTop" @click="back()">
          <v-icon left>remove_circle</v-icon>
          {{ $t("pages.UserExtraction.Create.Annulla") }}
        </v-btn>
      </v-flex>
      <v-alert :value="errorAlert" type="error" transition="scale-transition">
        {{ errorMessage }}
      </v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import usersApi from "../../apiSmartLogistics/usersApi.js";
import extractionsApi from "../../apiSmartLogistics/extractionApi.js";
import usersextractionsApi from "../../apiSmartLogistics/usersextractionsApi.js";
import debounce from "debounce";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  mixins: [validationMixin],

  validations: {
    user: { required, maxLength: maxLength(50) },
    extraction: { required, maxLength: maxLength(50) }
  },

  data: () => ({
    Id: 0,
    user: "",
    users: [],
    extraction: "",
    extractions: [],
    errorAlert: false,
    errorMessage: "",
    refreshMenu: ""
  }),

  computed: {
    edit() {
      //return this.$route.params.Id > 1;
      return this.$route.params.Id > 0;
    },

    extractionError() {
      const errors = [];
      if (!this.$v.extraction.$dirty) return errors;
      !this.$v.extraction.required &&
        errors.push(this.currentLanguage.t("Validations.EstrazioneRichiesta"));
      return errors;
    },
    usersErrors() {
      const errors = [];
      if (!this.$v.user.$dirty) return errors;
      !this.$v.user.required &&
        errors.push(this.currentLanguage.t("Validations.UtenteRichiesto"));
      return errors;
    },
    currentLanguage() {
      return Trans.i18n;
    }
  },

  created() {
    const Id = this.$route.params.Id;

    if (Id) {
      usersextractionsApi.GetViewUserExtraction(Id).then(response => {
        this.extraction = response.data.extractionId;
        this.user = response.data.userId;
      });
    }

    extractionsApi.GetExtractions().then(response => {
      this.extractions = response.data;
    });

    usersApi.GetUsers().then(response => {
      this.users = response.data;
    });
  },

  methods: {
    getExtractions() {
      extractionsApi.getExtractions().then(response => {
        this.extractions = response.data;
      });
    },

    loadUsers: debounce(function(event) {
      usersApi.SearchUsers(event.target.value).then(({ data }) => {
        this.user = data;
      });
    }, 200),

    creatingMapping() {
      this.$v.$touch();
      const Id = this.$route.params.Id;

      if (this.$v.user.error || this.$v.extraction.error) {
        return;
      }

      let userExtraction = {
        Id: Id,
        UserId: this.user,
        ExtractionId: this.extraction
      };

      if (Id) {
        usersextractionsApi
          .UpdateViewUsersExtractions(userExtraction)
          .then(() => {
            this.$emit("refreshMenu", this.refreshMenu);
            router.push({ name: "UsersExtractionsIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      } else {
        usersextractionsApi
          .InsertViewUsersExtractions(userExtraction)
          .then(() => {
            this.$emit("refreshMenu", this.refreshMenu);
            router.push({ name: "UsersExtractionsIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      }
    },

    back() {
      router.push({ name: "UsersExtractionsIndex" });
    },

    clear() {
      if (this.$route.params.Id) {
        this.$v.$reset();
        this.extractions = "";
        this.errorAlert = false;
      } else {
        this.$v.$reset();
        this.user = "";
        this.extractions = "";
        this.errorAlert = false;
      }
    }
  }
};
</script>
